import { usePublicLanguage } from "../../context/PublicLanguage";
import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatDate } from "@/lib/format";

export default function DailyDishBlock({ dish, compact = false }) {
  const { t, language } = usePublicLanguage();
  if (!dish) return null;
  return (
    <div
      className="relative rounded-lg overflow-hidden td-grain"
      style={{ background: "#1B1E21", borderTop: "2px solid #FF8A1F", border: "1px solid rgba(255,255,255,0.08)" }}
    >
      <div className="relative p-7 md:p-9">
        <div className="flex items-center gap-3 mb-4">
          <span className="td-eyebrow" style={{ color: "#FF8A1F" }}>{t('The Daily Dish')}</span>
          <span className="opacity-30 text-white">/</span>
          <span className="td-eyebrow" style={{ color: "#71767c", fontSize: "0.6rem" }}>
            {formatDate(dish.date, language)}
          </span>
        </div>
        <h2 className="font-display font-extrabold tracking-tight text-white text-2xl md:text-3xl mb-3" style={{ letterSpacing: "-0.02em" }}>{t('The technology that matters, today.')}</h2>
        <p className="text-[#A7ABB0] leading-relaxed max-w-2xl mb-7" style={{ fontSize: "1.02rem" }}>
          {dish.intro}
        </p>
        <ul className="space-y-4">
          {(compact ? dish.developments.slice(0, 3) : dish.developments).map((d, i) => (
            <li key={i} className="flex gap-4 items-start pb-4 border-b last:border-0" style={{ borderColor: "rgba(255,255,255,0.07)" }}>
              <span className="font-mono-td shrink-0 mt-0.5" style={{ color: "#FF8A1F", fontSize: "0.8rem" }}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="flex-1">
                <h4 className="font-display font-semibold text-white leading-snug">{d.heading}</h4>
                <p className="text-[#A7ABB0] leading-snug mt-1" style={{ fontSize: "0.92rem" }}>
                  {d.text}
                </p>
              </div>
              {d.link_slug && (
                <Link to={`/daily-dish`} className="text-[#71767c] hover:text-[#FF8A1F] transition-colors shrink-0 mt-1">
                  <ArrowUpRight size={16} />
                </Link>
              )}
            </li>
          ))}
        </ul>
        {compact && (
          <Link
            to="/daily-dish"
            data-testid="daily-dish-readmore"
            className="inline-flex items-center gap-1.5 mt-6 td-eyebrow hover:gap-2.5 transition-all"
            style={{ color: "#FF8A1F" }}
          >{t('Read the full briefing')}<ArrowUpRight size={14} />
          </Link>
        )}
      </div>
    </div>
  );
}
